import {Route} from "react-router-dom";
import RequireClient from "../helpers/requireClient";
import ClientLayout from "../scenes/layouts/client";
import {ClientHome} from "../scenes/pages/clientHome";
import React from "react";

const ClientRoutes = () => (
    <Route element={<RequireClient />}>
        <Route element={<ClientLayout />}>
            <Route path="/client/" element={<ClientHome />} />
        </Route>
    </Route>
);
export default ClientRoutes;